import UpdateSupplier from './UpdateSupplier'
export default UpdateSupplier
